module.exports = __webpack_public_path__ + "img/poker-d09.3a94f537.svg";